import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "@/contexts/AuthContext";
import ProtectedRoute from "@/components/app/ProtectedRoute";
import LoginPage from "@/pages/LoginPage";
import RegisterPage from "@/pages/RegisterPage";
import LandingPage from "@/pages/LandingPage";
import ScanPage from "@/pages/ScanPage";
import HistoryPage from "@/pages/HistoryPage";
import HaulTrackerPage from "@/pages/HaulTrackerPage";
import ExpensesPage from "@/pages/ExpensesPage";
import PnLDashboardPage from "@/pages/PnLDashboardPage";
import ProfilePage from "@/pages/ProfilePage";
import AdminPage from "@/pages/AdminPage";
import PrivacyPolicyPage from "@/pages/PrivacyPolicyPage";
import BulkUploadPage from "@/pages/BulkUploadPage";
import BulkArchivePage from "@/pages/BulkArchivePage";
import InventoryPage from "@/pages/InventoryPage";
import SizeCheckPage from "@/pages/SizeCheckPage";
import PrintSkuPage from "@/pages/PrintSkuPage";
import QuickListPage from "@/pages/QuickListPage";
import OnboardingPage from "@/pages/OnboardingPage";
import ConnectEbayPage from "@/pages/ConnectEbayPage";
import AdminUsagePage from "@/pages/AdminUsagePage";
import LedgerPage from "@/pages/LedgerPage";
import EnvBadge from "@/components/app/EnvBadge";
import { ConfirmProvider } from "@/components/app/ConfirmDialog";

function App() {
  return (
    <AuthProvider>
      <ConfirmProvider>
        <BrowserRouter>
        <EnvBadge />
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/register" element={<RegisterPage />} />
          <Route
            path="/scan"
            element={
              <ProtectedRoute>
                <ScanPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/history"
            element={
              <ProtectedRoute>
                <HistoryPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/hauls"
            element={<Navigate to="/scan" replace />}
          />
          <Route
            path="/expenses"
            element={<Navigate to="/scan" replace />}
          />
          <Route
            path="/pnl"
            element={<Navigate to="/scan" replace />}
          />
          <Route
            path="/bulk-archive"
            element={<Navigate to="/history" replace />}
          />
          {/* Pages kept-but-hidden — leave components intact in case we re-enable. */}
          <Route
            path="/__hidden/hauls"
            element={<ProtectedRoute><HaulTrackerPage /></ProtectedRoute>}
          />
          <Route
            path="/__hidden/expenses"
            element={<ProtectedRoute><ExpensesPage /></ProtectedRoute>}
          />
          <Route
            path="/__hidden/pnl"
            element={<ProtectedRoute><PnLDashboardPage /></ProtectedRoute>}
          />
          <Route
            path="/__hidden/bulk-archive"
            element={<ProtectedRoute><BulkArchivePage /></ProtectedRoute>}
          />
          <Route
            path="/profile"
            element={
              <ProtectedRoute>
                <ProfilePage />
              </ProtectedRoute>
            }
          />
          <Route path="/admin" element={<AdminPage />} />
          <Route path="/bulk-upload" element={<ProtectedRoute><BulkUploadPage /></ProtectedRoute>} />
          <Route path="/quick-list" element={<ProtectedRoute><QuickListPage /></ProtectedRoute>} />
          <Route path="/connect-ebay" element={<ProtectedRoute><ConnectEbayPage /></ProtectedRoute>} />
          <Route path="/admin/usage" element={<ProtectedRoute><AdminUsagePage /></ProtectedRoute>} />
          <Route path="/ledger" element={<ProtectedRoute><LedgerPage /></ProtectedRoute>} />
          <Route path="/onboarding" element={<ProtectedRoute allowOnboarding={true}><OnboardingPage /></ProtectedRoute>} />
          <Route path="/inventory" element={<ProtectedRoute><InventoryPage /></ProtectedRoute>} />
          <Route path="/size-check" element={<ProtectedRoute><SizeCheckPage /></ProtectedRoute>} />
          <Route path="/print-sku" element={<ProtectedRoute><PrintSkuPage /></ProtectedRoute>} />
          <Route path="/policy" element={<PrivacyPolicyPage />} />
          <Route path="/privacy" element={<PrivacyPolicyPage />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      </ConfirmProvider>
    </AuthProvider>
  );
}

export default App;
